import {
    UPDATE_PROFILE_STARTED,
    UPDATE_PROFILE_SUCCEEDED,
    UPDATE_PROFILE_FAILED,
    CANCEL_PROFILE_FORM,
    GET_PROFILE_STARTED,
    GET_PROFILE_SUCCEEDED,
    GET_PROFILE_FAILED,
    NO_PROFILE_AVAILABLE,
    RESET_ELEARN_PROFILE,
    ElearnProfileActionTypes,
    ElearnProfileModel,
} from './types';

const initialState = {
    updateCompleted: false,
    isLoading: false,
    source: '',
    error: '',
    isCancelled: false,
    profileData: {
        aiaMembershipNumber: '',
        ceVerifyNumber: '',
        contactId: '',
        designation: '',
        legalLicenses: [],
        pharmacyCredit: '',
        pharmacyCreditDOB: null,
        uniqueId: ''
    },
    noProfile: false,
};

const reducer = (
    state = initialState,
    action: ElearnProfileActionTypes
): ElearnProfileModel => {
    switch (action.type) {
        case UPDATE_PROFILE_STARTED: {
            return {
                ...state,
                isLoading: true,
                source: action.payload,
                error: '',
            };
        }
        case UPDATE_PROFILE_SUCCEEDED: {
            return {
                ...state,
                updateCompleted: true,
                isLoading: false,
                source: action.payload,
                error: '',
            };
        }
        case UPDATE_PROFILE_FAILED: {
            return {
                ...state,
                updateCompleted: false,
                isLoading: false,
                error: action.payload,
            };
        }
        case CANCEL_PROFILE_FORM: {
            return {
                ...state,
                isLoading: false,
                isCancelled: true,
            };
        }
        case GET_PROFILE_STARTED: {
            return {
                ...state,
                source: action.payload,
            };
        }
        case GET_PROFILE_SUCCEEDED: {
            return {
                ...state,
                profileData: action.payload,
            };
        }
        case GET_PROFILE_FAILED: {
            return {
                ...state,
                error: action.payload,
            };
        }
        case NO_PROFILE_AVAILABLE: {
            return {
                ...state,
                noProfile: true,
            };
        }
        case RESET_ELEARN_PROFILE: {
            return initialState;
        }
        default: {
            return state;
        }
    }
};

export default reducer;